import { inTestEnvironment } from './util/environment';

up.compiler('[autosave]', function(element, data) {
  const $element = $(element);
  const saveInterval = data.autosaveIntervalSeconds * 1000; // microseconds
  const bootTimeout = (inTestEnvironment()) ? 1 : 1500;
  const {
    newNote,
    noteId,
    siteId,
    enableUnchangedSnapshots
  } = data;
  const $form = $element.find('.autosave--form');
  const $inputs = $element.find('.autosave--input');
  const $cancelButton = $element.find('.autosave--cancel');
  const $reloadButton = $element.find('.autosave--reload');
  const $lastTextEditedAt = $element.find('.autosave--last-text-edited-at');
  let timeout = undefined;
  const cleanupAfter = 7 * 24 * 60 * 60 * 1000; // one week in ms

  const cleanupSnapshots = () => {
    for (let i = 0; i < localStorage.length; i++) {
      const localStorageKey = localStorage.key(i);

      if (localStorageKey && localStorageKey.match('^autosave_note_')) {
        const snapshot = LocalJsonStorage.getItem(localStorageKey);
        const snapshotDate = new Date(snapshot.timestamp);
        if (((new Date()) - snapshotDate) > cleanupAfter) {
          LocalJsonStorage.removeItem(localStorageKey);
        }
      }
    }
  };

  const buildSnapshot = function() {
    const snapshot = {
      timestamp: Date.now(),
      lastTextEditedAt: $lastTextEditedAt.val()
    };
    const payload = {};
    $inputs.each(function(index) {
      const $input = $(this);
      const name = $input.attr('name');
      const value = $input.val();
      payload[name] = value;
    });
    snapshot['payload'] = payload;
    return snapshot;
  };

  const saveNoteChanges = function() {
    const currentSnapshot = buildSnapshot();
    if (enableUnchangedSnapshots || snapshotsDiffer(snapshotOnPageLoad, currentSnapshot)) {
      LocalJsonStorage.setItem(storageKeyForNote(), currentSnapshot);
    }
    schedule();
  };

  var schedule = () => timeout = setTimeout(saveNoteChanges, saveInterval);

  const reset = () => clearTimeout(timeout);

  var storageKeyForNote = function() {
    if (newNote) {
      return `autosave_note_new_on_site_${siteId}`;
    } else {
      return `autosave_note_${noteId}`;
    }
  };

  const hasChangedSnapshot = function() {
    const savedSnapshot = LocalJsonStorage.getItem(storageKeyForNote());
    const currentSnapshot = buildSnapshot();
    return snapshotsDiffer(savedSnapshot, currentSnapshot);
  };

  var snapshotsDiffer = function(snapshot, otherSnapshot) {
    if (!snapshot) { return false; }
    if (!otherSnapshot) { return false; }
    return !up.util.isEqual(snapshot.payload, otherSnapshot.payload);
  };

  // do not restore, if saved snapshot was started with a different lastTextEditedAt (i.e. another user edited note in the meantime)
  const hasIncompatibleSnapshot = function() {
    const savedSnapshot = LocalJsonStorage.getItem(storageKeyForNote());
    if (!savedSnapshot) { return false; }
    // A snapshot is counted as compatible, if lastTextEditedAt is missing.
    // This will only occur for old snapshots before this commit.
    // Old snapshots (only valid for 7 days) will be able to accidentally override updates for up to 1 week after the deploy.
    // It was decided that this would be acceptable. Otherwise all old snapshots would have been lost immediately on deploy.
    if (!savedSnapshot.lastTextEditedAt) { return false; }
    return !up.util.isEqual(savedSnapshot.lastTextEditedAt, $lastTextEditedAt.val());
  };

  const checkRestoreSnapshot = function() {
    if (hasChangedSnapshot()) {
      const savedSnapshot = LocalJsonStorage.getItem(storageKeyForNote());
      const savedDate = new Date(savedSnapshot.timestamp);
      const confirmText = newNote ?
        `You started a new card for this deck on ${savedDate.toLocaleString()}. Do you want to restore these changes? Otherwise the changes will be discarded.`
      : hasIncompatibleSnapshot() ?
        `You edited this note on ${savedDate.toLocaleString()}.\n\nAnother user has edited this note in the meantime.\n\nDo you want to restore your changes? Afterwards, please copy your changes, reload the page and then merge your changes into the new version.\n\nClicking \"Cancel\" will discard your changes.`
      :
        `You edited this note on ${savedDate.toLocaleString()}. Do you want to restore these changes? Otherwise the changes will be discarded.`;
      if (confirm(confirmText)) {
        restoreSnapshot(savedSnapshot);
      }
      discardSnapshot();
    }
  };

  var restoreSnapshot = function(snapshot) {
    _.each(snapshot.payload, (value, inputName) => $inputs.filter(`[name='${inputName}']`).val(value));
    $lastTextEditedAt.val(snapshot.lastTextEditedAt);
  };

  var discardSnapshot = () => LocalJsonStorage.removeItem(storageKeyForNote());

  var snapshotOnPageLoad = buildSnapshot();
  $cancelButton.on('click', () => discardSnapshot());
  $reloadButton.on('click', () => discardSnapshot());
  $form.on('submit', () => discardSnapshot());
  cleanupSnapshots();

  const start = function() {
    checkRestoreSnapshot();
    schedule();
  };
  setTimeout(start, bootTimeout); // timeout to make sure all components have been loaded and rendered correctly

  return () => reset();
});


//#
// A wrapper around window.localStorage that automatically
// serializes items from/to JSON.
//
class LocalJsonStorage {
  static getItem(prop) {
    let item = localStorage.getItem(prop);
    if (_.isString(item)) { item = JSON.parse(item); }
    return item;
  }
  static setItem(prop, value) {
    value = JSON.stringify(value);
    return localStorage.setItem(prop, value);
  }
  static removeItem(prop) {
    return localStorage.removeItem(prop);
  }
}
